let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eU8IJ")).then(() => parcelRequire('hfe3g'));